import { CardContent, Skeleton, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { Card, CardTitle, Table } from '../../patient-profile-page.styles'; // Assuming these styles exist
import { Container } from './visits.styles';

function VisitsLoadingSkeleton() {
  return (
    <Container>
      <Card>
        <CardContent>
          <CardTitle>
            <Skeleton variant='text' width='40%' height={38} />
          </CardTitle>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell style={{ width: '15%' }}>Date</TableCell>
                <TableCell>Provider</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Insurance</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {[...Array(3)].map((_, index) => (
                <TableRow key={index}>
                  <TableCell>
                    <Skeleton variant='text' width='100%' />
                  </TableCell>
                  <TableCell>
                    <Skeleton variant='text' width='100%' />
                  </TableCell>
                  <TableCell>
                    <Skeleton variant='text' width='100%' />
                  </TableCell>
                  <TableCell>
                    <Skeleton variant='text' width='100%' />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>

      {/* Visit History Skeleton */}
      <Card>
        <CardContent>
          <CardTitle>
            <Skeleton variant='text' width='40%' height={38} />
          </CardTitle>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell style={{ width: '15%' }}>Date</TableCell>
                <TableCell>Description</TableCell>
                <TableCell style={{ width: '15%' }}>Revenue</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {[...Array(3)].map((_, index) => (
                <TableRow key={index}>
                  <TableCell>
                    <Skeleton variant='text' width='100%' />
                  </TableCell>
                  <TableCell>
                    <Skeleton variant='text' width='100%' />
                  </TableCell>
                  <TableCell>
                    <Skeleton variant='text' width='100%' />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </Container>
  );
}

export default VisitsLoadingSkeleton;
